import * as React from 'react';
import { useRouter } from 'next/router';
import { LoaderScreen } from '@grandvisionhq/common';
import { StringGuard } from '@grandvisionhq/utils';
import { SocialLoginModalContainer } from '../components/SocialLoginModal/SocialLoginModalContainer.js';

const Callback = ({ parseHash , loggedOut , type  })=>{
    const [loginMethod, setLoginMethod] = React.useState('');
    const { query  } = useRouter();
    React.useEffect(()=>{
        if (query.loginMethod) {
            setLoginMethod(StringGuard.guard('social.loginMethod', query.loginMethod));
        }
        /**
     * When we are in the social login flow, we need to give the user the chance to indicate
     * they want to merge accounts. While they make a choice, we don't want to parse the URL hash yet.
     *
     * parseHash will be triggered from the SocialLoginModal.
     */ if (loginMethod === 'social') {
            return;
        }
        if (type === 'callback') {
            return parseHash();
        }
        return loggedOut();
    }, [
        type,
        parseHash,
        loggedOut,
        query.loginMethod,
        loginMethod
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LoaderScreen, {
        height: 50
    }), loginMethod === 'social' && /*#__PURE__*/ React.createElement(SocialLoginModalContainer, {
        parseHash: parseHash
    }));
};
var Callback$1 = Callback;

export { Callback$1 as default };
//# sourceMappingURL=Callback.js.map
